import STORE from '../../store';
import invalidateMetricCache from '../metrics/invalidateMetricCache';

const createCompoundMetric = async (
  metric: Metrics.CompoundMetric,
  selectedAccountId: string,
) => {
  await STORE.metricDefinitions
    .getCompoundMetricsRef({ accountId: selectedAccountId })
    .doc(metric.id)
    .set(metric);

  await invalidateMetricCache({
    accountId: selectedAccountId,
    compoundMetricIds: [metric.id],
  });
};

export default createCompoundMetric;
